
import { Component } from 'vue-property-decorator';
import ListBase from '@/lib/listbase';
import Ajax from '@/lib/ajax';
import Util from '@/lib/util';
import VWidget from '@/components/VWidget.vue';

@Component({ components: { VWidget } })
export default class LoginVisualAssets extends ListBase {
    background: any = null;
    logos: any[] = [];
    backgroundFile: File = null;
    logoFile: File = null;
    logoName: string = '';
    savingBackground: boolean = false;
    restoringBackground: boolean = false;
    savingLogo: boolean = false;
    confirmDialog: boolean = false;
    confirming: boolean = false;
    confirmTitle: string = '';
    confirmMessage: string = '';
    pendingAction: string = '';
    pendingLogo: any = null;

    get backgroundUrl() {
        return this.background ? this.background.url : '/static/login-background.jpg';
    }

    async loadAssets() {
        const response = await Ajax.get('/api/login-visual-assets');
        this.applyAssets(response.data.result);
    }

    async replaceBackground() {
        if (!this.backgroundFile) return;
        this.savingBackground = true;
        try {
            const data = new FormData();
            data.append('image', this.backgroundFile);
            const response = await Ajax.post('/api/login-visual-assets/background', data);
            this.applyAssets(response.data.result);
            this.backgroundFile = null;
            Util.abp.notify.success(this, 'La imagen de fondo fue actualizada.');
        } finally {
            this.savingBackground = false;
        }
    }

    async addLogo() {
        if (!this.logoFile || !this.logoName.trim()) return;
        this.savingLogo = true;
        try {
            const data = new FormData();
            data.append('name', this.logoName.trim());
            data.append('image', this.logoFile);
            const response = await Ajax.post('/api/login-visual-assets/logos', data);
            this.applyAssets(response.data.result);
            this.logoName = '';
            this.logoFile = null;
            Util.abp.notify.success(this, 'El logo fue agregado.');
        } finally {
            this.savingLogo = false;
        }
    }

    requestRestoreBackground() {
        this.pendingAction = 'restore-background';
        this.pendingLogo = null;
        this.confirmTitle = 'Restaurar fondo';
        this.confirmMessage = 'Se eliminará el fondo personalizado y se mostrará nuevamente la imagen predeterminada.';
        this.confirmDialog = true;
    }

    requestRemoveLogo(logo: any) {
        this.pendingAction = 'remove-logo';
        this.pendingLogo = logo;
        this.confirmTitle = 'Eliminar marca';
        this.confirmMessage = `Se eliminará el logo de ${logo.name}.`;
        this.confirmDialog = true;
    }

    async confirmAction() {
        this.confirming = true;
        try {
            if (this.pendingAction === 'restore-background') await this.restoreBackground();
            if (this.pendingAction === 'remove-logo') await this.removeLogo(this.pendingLogo);
            this.closeConfirmation();
        } finally {
            this.confirming = false;
        }
    }

    closeConfirmation() {
        this.confirmDialog = false;
        this.pendingAction = '';
        this.pendingLogo = null;
    }

    async restoreBackground() {
        this.restoringBackground = true;
        try {
            const response = await Ajax.delete('/api/login-visual-assets/background');
            this.applyAssets(response.data.result);
            this.backgroundFile = null;
            Util.abp.notify.success(this, 'Se restauró el fondo predeterminado.');
        } finally {
            this.restoringBackground = false;
        }
    }

    async removeLogo(logo: any) {
        const response = await Ajax.delete(`/api/login-visual-assets/logos/${logo.id}`);
        this.applyAssets(response.data.result);
        Util.abp.notify.success(this, 'El logo fue eliminado.');
    }

    applyAssets(assets: any) {
        this.background = assets.background;
        this.logos = assets.logos || [];
    }

    mounted() {
        this.loadAssets();
    }
}
